import type { IsToolActive } from "./types";

/**
 * Which tool is lit, from the ONE value that knows.
 *
 * It used to ask two stores — the queue's arm for Add/Remove, the edit layer's
 * `shapeEditCircuit` for Reshape — with nothing reconciling them, so Remove and
 * Reshape lit together: "there should be no way this 2 buttons active together".
 * Being told to keep two stores in step is what drifts; reading one cannot.
 */
export const isToolActive: IsToolActive = ({ tool, activeTool }) => {
  if (!activeTool) return false;
  const { action } = tool;

  // Two runs can carry the same tool. Being on for one of them must not light
  // the tile on the other.
  if (action.kind === "editRouteShape")
    return activeTool.kind === "shape" && activeTool.circuitId === action.circuitId;
  if (action.kind === "boxAssign")
    return activeTool.kind === "add" && activeTool.circuitId === action.circuitId;
  if (action.kind === "boxRemove")
    return activeTool.kind === "remove" && activeTool.circuitId === action.circuitId;

  return false;
};
